import React from 'react';
export function Footer() {
  return <footer className="w-full px-4 sm:px-6 lg:px-8 py-10" style={{
    background: 'linear-gradient(180deg, #FDF4E7 0%, #FEFAF4 50%, #FEFAF4 100%)',
    borderTop: '1px solid rgba(200,146,42,0.22)'
  }} data-id="element-179">
      <div className="mx-auto max-w-4xl text-center" data-id="element-180">
        {/* Logo */}
        <div className="mb-3 font-black tracking-[2.4px] text-[18px]" style={{
        color: '#C8922A'
      }} data-id="element-181">
          📖 BIBLIOTECA PROFESIONAL™
        </div>

        {/* Tagline */}
        <p className="mx-auto max-w-[576px] text-xs leading-[20px] m-0 mb-3" style={{
        color: '#6B4C35'
      }} data-id="element-182">
          El sistema N°1 para estudiantes de Psicología que quieren resolver la
          carrera, aprobar sin recursar y recibirse en tiempo.
        </p>

        <p className="text-xs italic m-0 mb-6 px-4" style={{
        color: '#9A7B5A'
      }} data-id="element-183">
          "Porque estudiar Psicología no debería costarte todas tus noches y
          fines de semana buscando bibliografía dispersa."
        </p>

        {/* Contact Info */}
        <div className="mb-6 flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6 text-xs" style={{
        color: '#6B4C35'
      }} data-id="element-184">
          <a href="mailto:construyeprogresoo@gmail.com" className="no-underline transition-colors" style={{
          color: '#6B4C35'
        }} onMouseEnter={e => e.currentTarget.style.color = '#C8922A'} onMouseLeave={e => e.currentTarget.style.color = '#6B4C35'} data-id="element-185">
            📧 soporte@bibliotecaprofesional.com
          </a>
          <span className="hidden sm:block" style={{
          color: 'rgba(200,146,42,0.30)'
        }} data-id="element-186">
            |
          </span>
          <span style={{
          color: '#6B4C35'
        }} data-id="element-187">
            📲 @BibliotecaProfesional
          </span>
          <span className="hidden sm:block" style={{
          color: 'rgba(200,146,42,0.30)'
        }} data-id="element-188">
            |
          </span>
          <a href="https://www.construyeprogreso.com" target="_blank" rel="noopener noreferrer" className="no-underline transition-colors" style={{
          color: '#6B4C35'
        }} onMouseEnter={e => e.currentTarget.style.color = '#C8922A'} onMouseLeave={e => e.currentTarget.style.color = '#6B4C35'} data-id="element-189">
            🌐 www.bibliotecaprofesional.com
          </a>
        </div>

        {/* Divider */}
        <div className="mx-auto mb-6 h-px w-24" style={{
        background: 'linear-gradient(to right, transparent, rgba(200,146,42,0.45), transparent)'
      }} data-id="element-190" />

        {/* Legal & Copyright */}
        <div className="space-y-1" data-id="element-191">
          <p className="text-[10px] m-0" style={{
          color: '#9A7B5A'
        }} data-id="element-192">
            © {new Date().getFullYear()} Biblioteca Profesional™ — Todos los
            derechos reservados.
          </p>
          <p className="text-[10px] m-0" style={{
          color: 'rgba(154,123,90,0.70)'
        }} data-id="element-193">
            Prohibida la reproducción total o parcial y la redistribución sin
            autorización expresa.
          </p>
        </div>
      </div>
    </footer>;
}